import { useEffect, useState } from "react";

const IG_URL = "https://www.instagram.com/cerenza_familyphotoroom";
const DISMISS_KEY = "cerenza-ig-sticky-dismissed";

export default function InstagramSticky() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY) === "1") {
      setDismissed(true);
      return;
    }
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
      setVisible(scrolled >= 0.55);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (dismissed) return null;

  const close = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="diary-ig-sticky"
      aria-hidden={!visible}
      className={`fixed z-40 bottom-5 right-4 md:right-6 max-w-[calc(100vw-2rem)] transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-3 pl-4 pr-2 py-2 bg-cerenza-cherry text-cerenza-creamlight rounded-full shadow-[0_14px_40px_-12px_rgba(220,45,63,0.6)] border border-cerenza-pink/40">
        <a
          href={IG_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="diary-ig-sticky-link"
          className="flex items-center gap-2.5 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-cerenza-creamlight/15 group-hover:bg-cerenza-creamlight/25 transition-colors">
            <svg viewBox="0 0 24 24" className="w-4.5 h-4.5" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
            </svg>
          </span>
          <span className="hidden sm:flex flex-col leading-tight pr-2">
            <span className="text-[10px] uppercase tracking-[0.18em] text-cerenza-pink font-semibold">
              ¿Te gustó este momento?
            </span>
            <span className="text-sm font-semibold">Mira más en Instagram →</span>
          </span>
          <span className="sm:hidden text-sm font-semibold pr-1">Instagram →</span>
        </a>
        <button
          type="button"
          onClick={close}
          aria-label="Cerrar"
          data-testid="diary-ig-sticky-close"
          className="h-8 w-8 inline-flex items-center justify-center rounded-full bg-cerenza-creamlight/15 hover:bg-cerenza-creamlight/30 transition-colors"
        >
          <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </div>
    </div>
  );
}
